
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Warmingsystempune() {



  const cardData =
  {
    keyword: 'Patient Warming System in Pune',
    heading: 'Pharmacle Health Care Private Limited: Patient Warming System in Pune',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Patient Warming System in Pune, ensuring effective temperature management for patients during surgeries and critical care. Our advanced warming systems help prevent hypothermia by delivering consistent and controlled heat, enhancing patient safety and recovery. Widely used in hospitals and healthcare facilities, our patient warming systems are reliable, easy to use, and designed with cutting-edge technology. Choose Pharmacle Health Care for the best warming solutions in Pune to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


  "topPlaces": [
  {
    "title": "Top-Quality Patient Warming System in Pune",
    "description": "Pharmacle Health Care Private Limited provides advanced Patient Warming Systems in Pune, ensuring precise temperature regulation for patients undergoing medical procedures. Our systems help prevent hypothermia, enhance patient recovery, and improve overall treatment outcomes in hospitals and clinics."
  },
  {
    "title": "Best Surgical Patient Warming Solutions",
    "description": "Designed for operating rooms, our surgical warming systems deliver consistent and even heat distribution, ensuring patients maintain optimal body temperature during critical procedures. These systems reduce the risk of hypothermia and promote faster post-surgical recovery."
  },
  {
    "title": "ICU Patient Warming Systems for Critical Care",
    "description": "Our ICU-specific warming systems offer precise temperature control for critically ill patients, aiding in faster healing and improved vital stability. These systems are essential for maintaining normothermia in intensive care units, reducing complications and enhancing patient comfort."
  },
  {
    "title": "Effective Preoperative & Postoperative Warming Systems",
    "description": "Our pre- and post-surgery warming systems help stabilize body temperature, minimizing the risk of perioperative hypothermia. These systems ensure that patients remain warm before and after surgery, leading to improved healing and reduced postoperative discomfort."
  },
  {
    "title": "Emergency Patient Warming System for Trauma Care",
    "description": "Pharmacle Health Care Private Limited offers rapid-response warming systems designed for emergency rooms. These systems provide immediate temperature stabilization for trauma patients, hypothermia cases, and individuals in shock, enhancing survival chances and recovery speed."
  },
  {
    "title": "Neonatal Warming Systems for Newborns & Infants",
    "description": "Our neonatal warming systems are specially designed for NICUs and maternity wards, ensuring gentle and controlled warmth for newborns. These systems help regulate the body temperature of premature and low-birth-weight infants, promoting healthy growth and development."
  },
  {
    "title": "Portable Patient Warming System for On-the-Go Care",
    "description": "Our compact and lightweight portable warming systems are ideal for ambulances, field hospitals, and home healthcare. Designed for mobility, these systems provide reliable and effective warming solutions for patients requiring temperature management during transport."
  },
  {
    "title": "Veterinary Patient Warming System for Animal Care",
    "description": "Pharmacle Health Care Private Limited extends its expertise to veterinary clinics with specialized warming systems for pets and livestock. These systems help maintain stable body temperature during surgeries and treatments, ensuring better outcomes in animal care."
  },
  {
    "title": "Hospital-Grade Warming Systems for Advanced Care",
    "description": "Our hospital-grade warming systems provide high-performance temperature regulation for various medical applications. Designed for efficiency, these systems ensure patient safety and comfort in healthcare facilities across Pune."
  },
  {
    "title": "Hygienic Disposable Warming Blankets for Patient Safety",
    "description": "Pair our patient warming systems with premium disposable warming blankets for a single-use, contamination-free experience. These blankets provide effective heat retention, ensuring patient warmth while reducing infection risks in hospitals and clinics."
  }
],

      "services": [
        {
            "name": "Patient Warming System Pune",
            "description": "Pharmacle Health Care Private Limited offers patient warming systems in Pune, designed to regulate and maintain body temperature during medical procedures. These systems help prevent hypothermia, ensuring optimal temperature control and patient safety throughout surgeries and recovery."
        },
        {
            "name": "Pune Patient Warming Devices",
            "description": "We provide patient warming devices in Pune, specifically designed to regulate body temperature during medical treatments. These devices ensure patient comfort and safety by preventing temperature-related complications during surgeries, recovery, and critical care."
        },
        {
            "name": "Forced Air Warming Systems Pune",
            "description": "Our forced air warming systems in Pune are designed to circulate warm air and maintain patient body temperature during medical procedures. These systems are effective in preventing hypothermia, providing a comfortable and controlled environment throughout surgeries and recovery."
        },
        {
            "name": "Medical Warming Solutions Pune",
            "description": "We offer medical warming solutions in Pune, designed to regulate and maintain body temperature during surgeries and critical care procedures. These solutions ensure patient comfort and safety, preventing temperature-related complications during medical treatments."
        },
        {
            "name": "Pune Patient Thermoregulation Systems",
            "description": "Pharmacle Health Care provides patient thermoregulation systems in Pune, designed to ensure optimal body temperature during surgeries and medical treatments. These systems help to manage the patient’s temperature, creating a safe and comfortable environment throughout their care."
        },
        {
            "name": "Pune Warming Equipment Supplier",
            "description": "We are a leading supplier of warming equipment in Pune, offering advanced solutions for maintaining body temperature during medical procedures. Our equipment ensures patient safety and comfort by regulating body temperature, preventing hypothermia during surgeries and recovery."
        }
    ],
    "tableData": [
        ["- Patient Warming System Pune", "- Pune Patient Warming Devices"],
        ["- Forced Air Warming Systems Pune", "- Medical Warming Solutions Pune"],
        ["- Pune Patient Thermoregulation Systems", "- Pune Warming Equipment Supplier"]
    ],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced patient warming systems in Pune, designed to provide precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics across the Pune region."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a wide range of patient warming systems in Pune, including warming devices, blankets, and temperature control systems. Our solutions are tailored for both surgical procedures and critical care, ensuring your patients remain comfortable and safe throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient warming systems are manufactured to the highest quality standards, ensuring durability and long-lasting performance. Regularly tested and maintained, our systems provide optimal reliability for continuous use in medical settings throughout Pune."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our patient warming systems provide controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring that patients in Pune are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient warming systems in Pune are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs, improving overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s patient warming systems are designed for seamless integration with existing medical systems in Pune. Our products can be quickly implemented, ensuring smooth and efficient operation without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services in Pune to help healthcare facilities select the right patient warming systems for their needs. Our team also offers ongoing support and maintenance to ensure your equipment operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our patient warming systems are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Pune receives the highest standard of care."
    }
]













  }

  const faqData = [
    { question: "What is a Forced Air Warming System?", answer: "A Forced Air Warming System is a medical device used to regulate and maintain a patient’s body temperature during surgeries and medical procedures. It works by blowing warm air through a special warming blanket or pad placed over the patient." },
    { question: "How does the Forced Air Warming System work?", answer: "The system works by using a blower to circulate warm air through a blanket or pad that is placed on the patient’s body. This helps prevent hypothermia by maintaining the patient’s body temperature within a safe and comfortable range." },
    { question: "Is the Forced Air Warming System available in Pune?", answer: "Yes, Pharmacle Health Care Private Limited offers the Forced Air Warming System in Pune, providing hospitals and healthcare facilities with an effective solution to maintain patient body temperature during medical treatments." },
    { question: "What are the benefits of using a Forced Air Warming System?", answer: "The benefits include preventing hypothermia, reducing surgical complications, improving patient comfort, speeding up recovery times, and ensuring a stable body temperature throughout medical procedures." },
    { question: "How long can the Forced Air Warming System maintain the patient’s temperature?", answer: "The Forced Air Warming System can maintain the patient’s body temperature for the entire duration of the medical procedure, ensuring consistent warmth and temperature control." },
    { question: "Is the Forced Air Warming System easy to use?", answer: "Yes, the system is designed to be user-friendly, with simple controls that allow healthcare professionals to adjust the temperature settings quickly and efficiently." },
    { question: "Can the Forced Air Warming System be used for all types of surgeries?", answer: "Yes, the Forced Air Warming System is versatile and can be used in a wide range of surgeries and medical procedures, particularly those where maintaining normothermia is essential for patient safety." },
    { question: "Is the Forced Air Warming System safe for all patients?", answer: "Yes, the system is generally safe for most patients. However, it should always be used under the supervision of trained healthcare professionals to ensure proper temperature regulation and avoid overheating or underheating." },
    { question: "How can I purchase a Forced Air Warming System in Pune?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you with purchasing and delivering the Forced Air Warming System to your healthcare facility in Pune." },
    { question: "Does Pharmacle Health Care provide support for the Forced Air Warming System?", answer: "Yes, we offer complete support for the Forced Air Warming System, including installation, training for healthcare professionals, and ongoing maintenance to ensure optimal performance." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using the Patient Warming System from Pharmacle Health Care in our Pune hospital. It has greatly improved the comfort and safety of our patients during surgeries by maintaining their body temperature.',
      name: 'Dr. Vikram Joshi',
    },
    {
      text: 'The Patient Warming System from Pharmacle Health Care has been a valuable addition to our clinic in Pune. It is easy to use and ensures that our patients are kept at the ideal temperature during medical procedures.',
      name: 'Pune Medical Center',
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];

  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Warming System in Pune",
    "description": "Discover advanced Patient Warming Systems in Pune for effective patient thermoregulation and temperature control. Our systems ensure optimal comfort and safety during medical treatments and surgeries.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "1644"
    }
  };
  
 



  return (
    <div>
 <Helmet>
    <title>Patient Warming System in Pune | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Explore Patient Warming Systems in Pune for effective thermoregulation and temperature management during medical treatments. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Warming System Pune, Pune Patient Warming Devices, Forced Air Warming Systems Pune, Medical Warming Solutions Pune, Pune Patient Thermoregulation Systems, Pune Warming Equipment Supplier"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/19.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Warmingsystempune;